import { rankingItems } from '@/mocks/home';

function TrendIcon({ trend }: { trend: string }) {
  if (trend === 'up') return <i className="ri-arrow-up-line text-xs" />;
  if (trend === 'down') return <i className="ri-arrow-down-line text-xs" />;
  return <i className="ri-subtract-line text-xs" />;
}

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            热门榜单
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            实时热度排名，看看本周最受漫友追捧的漫画作品
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden">
            {rankingItems.map((item, idx) => (
              <div
                key={item.id}
                className={`flex items-center gap-4 px-5 md:px-6 py-4 ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200/40' : ''
                } hover:bg-background-50 transition-colors cursor-pointer`}
              >
                <div className="flex items-center justify-center w-9 h-9 rounded-lg flex-shrink-0">
                  {item.rank === 1 ? (
                    <span className="font-heading text-xl text-accent-500">1</span>
                  ) : item.rank === 2 ? (
                    <span className="font-heading text-xl text-primary-500">2</span>
                  ) : item.rank === 3 ? (
                    <span className="font-heading text-xl text-secondary-700">3</span>
                  ) : (
                    <span className="font-semibold text-base text-foreground-500">{item.rank}</span>
                  )}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-sm text-foreground-950 truncate">
                    {item.title}
                  </div>
                  <div className="text-xs text-foreground-400 mt-0.5">{item.author}</div>
                </div>

                <div className="flex items-center gap-3 flex-shrink-0">
                  <div className="text-right">
                    <div className="text-sm font-semibold text-primary-600">{item.heat}</div>
                    <div className="text-[11px] text-foreground-400">热度</div>
                  </div>
                  <span
                    className={`flex items-center gap-0.5 text-xs font-medium px-2 py-1 rounded ${
                      item.trend === 'up'
                        ? 'text-primary-700 bg-primary-50'
                        : item.trend === 'down'
                          ? 'text-accent-600 bg-accent-50'
                          : 'text-foreground-400 bg-background-200'
                    }`}
                  >
                    <TrendIcon trend={item.trend} />
                    {item.change}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}